import React from 'react';
import { Tooltip } from 'antd';

export const ButtonToolTip = (props:any) => {
    const { title = '', disabledButtonTitle = '' } = props;
    if (props.disabled || title) {
      return (
        <Tooltip overlayClassName='tooltip' placement='top' title={props.disabled ? disabledButtonTitle : title}>
          {props.children}
        </Tooltip>
      );
    }
    return props.children;
  };